import React from 'react';
import { ComponentType } from 'react';
import EmptyLayout from '@/components/layout/EmptyLayout';

export interface RouteConfig {
    path: string;
    component: React.LazyExoticComponent<ComponentType<any>>;
    layout?: ComponentType<{ children: React.ReactNode }>;
    isIndex?: boolean;
    category?: string;
    title?: string;
    icon?: string;
}

// Helper function for better TypeScript inference
const lazyImport = <T extends ComponentType<any>>(
    factory: () => Promise<{ default: T }>
) => React.lazy(factory);

export const protectedRoutes: RouteConfig[] = [
    { path: 'complete-onboarding', component: lazyImport(() => import('@/pages/VendorOnboarding')), layout: EmptyLayout },
    { path: 'onboarding-completed', component: lazyImport(() => import('@/pages/OnboardingComplete')), layout: EmptyLayout },

    { path: 'dashboard', component: lazyImport(() => import('@/pages/DashboardPage')) },
    { path: 'orders', component: lazyImport(() => import('@/pages/Orders')) },
    { path: 'menu', component: lazyImport(() => import('@/pages/Menu')) },
    { path: 'categories', component: lazyImport(() => import('@/pages/Categories')) },
    { path: 'branches', component: lazyImport(() => import('@/pages/BranchManagement')), title: 'Branches', category: 'Management', icon: 'Store' },
    { path: 'analytics', component: lazyImport(() => import('@/pages/Analytics')) },
    { path: 'advanced-analytics', component: lazyImport(() => import('@/pages/AdvancedAnalytics')) },
    { path: 'ai-analytics', component: lazyImport(() => import('@/pages/AIAnalytics')) },
    { path: 'engagement', component: lazyImport(() => import('@/pages/EngagementPage')), title: 'Engagement', category: 'Analytics', icon: 'Activity' },
    { path: 'personalization', component: lazyImport(() => import('@/pages/PersonalizationManagement')) },
    { path: 'competitive-intelligence', component: lazyImport(() => import('@/pages/CompetitiveIntelligence')) },
    { path: 'inventory-management', component: lazyImport(() => import('@/pages/InventoryManagement')) },
    { path: 'customers', component: lazyImport(() => import('@/pages/Customers')) },
    { path: 'notifications', component: lazyImport(() => import('@/pages/Notifications')) },
    { path: 'website', component: lazyImport(() => import('@/pages/WebsiteManagement')) },
    // { path: 'gamification', component: lazyImport(() => import('@/pages/Gamification')) },
    // { path: 'team-gamification', component: lazyImport(() => import('@/pages/TeamGamification')) },
    // { path: 'rider-incentives', component: lazyImport(() => import('@/pages/RiderIncentives')) },
    { path: 'whatsapp', component: lazyImport(() => import('@/pages/WhatsAppManagement')) },
    { path: 'whatsapp-takeover', component: lazyImport(() => import('@/pages/WhatsAppTakeover')) },
    { path: 'payment-management', component: lazyImport(() => import('@/pages/PaymentManagement')) },
    { path: 'payout-monitoring', component: lazyImport(() => import('@/pages/PayoutMonitoring')) },
    { path: 'monitoring', component: lazyImport(() => import('@/pages/SystemMonitoring')) }, { path: 'ai-website-generator', component: lazyImport(() => import('@/pages/AIWebsiteGenerator')) }, { path: 'vendor-gamification', component: lazyImport(() => import('@/pages/VendorGamification')) },
    { path: 'wallet-management', component: lazyImport(() => import('@/pages/WalletManagement')) },
    { path: 'customer-personalization', component: lazyImport(() => import('@/pages/CustomerPersonalization')) },
    { path: 'ai-analytics-dashboard', component: lazyImport(() => import('@/pages/AIAnalyticsDashboard')) },
    // { path: 'commission-management', component: lazyImport(() => import('@/pages/CommissionManagement')) },
    { path: 'settings', component: lazyImport(() => import('@/pages/Settings')) },
    { path: 'categories', component: lazyImport(() => import('@/pages/Categories')) },
];

// For public routes
import LoginForm from '@/pages/auth/Login';
import Registration from '@/pages/auth/Registration';
import ForgotPassword from '@/pages/auth/ForgotPassword';



export interface PublicRouteConfig {
    path: string;
    component: ComponentType<any>;
}

export const publicRoutes: PublicRouteConfig[] = [
    { path: 'login', component: LoginForm },
    { path: 'signup', component: Registration },
    { path: 'forgot-password', component: ForgotPassword },
];